import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { selectClientId } from 'src/store/selectors/client'
import { selectHomeId } from 'src/store/selectors/home'
import { selectActiveTab } from 'src/store/selectors/navigation'
import { PATH_HELPERS, TAB_NAMES } from 'src/constants/navigation'

const RedirectToHomeDigest = () => {
  const clientId = useSelector(selectClientId)
  const homeId = useSelector(selectHomeId)
  const tabName = useSelector(selectActiveTab)

  if (!clientId) {
    return <Redirect to='/not-found' />
  }

  switch (tabName) {
    case TAB_NAMES.HOMES:
      return <Redirect to={PATH_HELPERS.home.buildPath(clientId, homeId)} />

    case TAB_NAMES.BUYER:
      return <Redirect to={PATH_HELPERS.buy.buildPath(clientId)} />

    case TAB_NAMES.MARKET:
      return <Redirect to={PATH_HELPERS.markets.buildPath(clientId)} />

    default:
      return null
  }
}

export default RedirectToHomeDigest
